/*
 * @Author: weiyanna
 * @Date: 2022-04-06 13:59:06
 * @LastEditTime: 2026-03-24 09:16:00
 * @LastEditors: weiyanna weiyanna@jd.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /isp_pro/src/enum/localStorage.ts
 */

/***
 * 默认地址
 */
export const DEFAULT_CHANGE_ADDRESS = 'default_change_address';
export const SEARCH_PVID_LOGID = 'search_pvId_logId' //垂搜埋点pvId以及logId
